module.exports = __webpack_public_path__ + "static/media/Rectangle2899.190cbfa6.png";